import { VERBS, type Verb } from '@/game/view/verbs';

/** A verb's glyph, decorative: the label beside it carries the meaning. */
export function VerbGlyph({ verb }: { verb: Verb }) {
  return <span aria-hidden>{VERBS[verb].glyph}</span>;
}

/** "⬆ Upgrade": the glyph, then `children` (default: the verb's label). */
export function VerbLabel({ verb, children }: { verb: Verb; children?: React.ReactNode }) {
  return (
    <>
      <VerbGlyph verb={verb} /> {children ?? VERBS[verb].label}
    </>
  );
}
